import { render, staticRenderFns } from "./EditExpense.vue?vue&type=template&id=574602e4&scoped=true&"
import script from "./EditExpense.vue?vue&type=script&lang=ts&"
export * from "./EditExpense.vue?vue&type=script&lang=ts&"
import style0 from "./EditExpense.vue?vue&type=style&index=0&id=574602e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574602e4",
  null
  
)

export default component.exports